export default "__VITE_ASSET__Dtdy5jIe__"